<section class="header" [ngStyle]="{ 'background-color': backgroundColor }">
    <div *ngIf="(isMobile$ | async) === false" class="background" [ngStyle]="{ 'background-image': 'url('+backgroundImagePath+')'}"></div>
    <div *ngIf="(isMobile$ | async)" class="background small" [ngStyle]="{ 'background-image': 'url('+smallBackgroundImagePath+')'}"></div>
    <div class="main">
        <div class="container">
            <ng-content></ng-content>
        </div>
    </div>
</section>